/**
 * MobileTabBar — Bottom tab bar for mobile (<768px).
 * v4.8 Spec Section 3: "Bottom tab bar on mobile."
 *
 * 5 tabs: Home, Projects, Alerts, AI, More.
 * 44px minimum touch targets (Apple HIG).
 * Glass effect background.
 */

import { NavLink } from 'react-router-dom';
import { MOBILE_TABS } from './navigation';
import { NavIcon } from './NavIcon';

export function MobileTabBar(): React.ReactElement {
  return (
    <nav
      className="
        md:hidden fixed bottom-0 left-0 right-0 z-50
        glass-card border-t border-border-light dark:border-border-dark
        rounded-none
        pb-[env(safe-area-inset-bottom)]
      "
    >
      <div className="flex items-center justify-around px-2 py-1">
        {MOBILE_TABS.map((tab) => (
          <NavLink
            key={tab.key}
            to={tab.path}
            end={tab.path === '/'}
            className={({ isActive }) => `
              flex flex-col items-center justify-center gap-0.5
              min-w-[44px] min-h-[44px] px-2 py-1
              transition-colors duration-fast
              ${
                isActive
                  ? 'text-gold dark:text-gold-400'
                  : 'text-text-secondary dark:text-text-dark-secondary'
              }
            `}
          >
            <NavIcon name={tab.icon} className="w-[22px] h-[22px]" />
            <span className="text-[10px] font-medium leading-tight">{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
